import { handleTileSync } from "../search/searchUtils";
import { globalUtilInit, loadLazyImages } from "../utilities/globalUtilities";

const $document = $(document);

const getCustomerProductIds = async () => {
    if (!window.wishlistProductIds) {
        window.wishlistProductIds = await new Promise((resolve, reject) => {
            $.ajax({
                url: $(".js-wishlist-get-product-ids").attr("data-url"),
                success: (data) => resolve(data.productIds || []),
                error: (err) => reject(err)
            });
        });
    }

    return window.wishlistProductIds;
};

const initTogglers = async () => {
    const $elems = $(".wishlist-toggler:not([data-initialized])");
    const isAuthenticated = window.IS_CUSTOMER_AUTHENTICATED || $(".user-authenticated").length > 0;
    let wishlistProductIds = [];

    if ($elems.length > 0 && isAuthenticated) {
        wishlistProductIds = await getCustomerProductIds();
    }

    $elems.each((_, elem) => {
        const $elem = $(elem);
        const pid = $elem.attr("data-pid");

        if (isAuthenticated) {
            if (wishlistProductIds.indexOf(pid) > -1) {
                $elem
                    .addClass("active")
                    .removeClass("inactive")
                    .removeClass($elem.attr("data-custom-inactive-class"))
                    .addClass($elem.attr("data-custom-active-class"))
                    .attr("aria-label", $elem.attr("data-tooltip-active-message"))
                    .attr("data-original-title", $elem.attr("data-tooltip-active-message"));
            } else {
                $elem
                    .addClass("inactive")
                    .removeClass("active")
                    .removeClass($elem.attr("data-custom-active-class"))
                    .addClass($elem.attr("data-custom-inactive-class"))
                    .attr("aria-label", $elem.attr("data-tooltip-inactive-message"))
                    .attr("data-original-title", $elem.attr("data-tooltip-inactive-message"));
            }
            
            if ($elem.attr("data-enable-tooltip") === "true") {
                $elem.tooltip({ trigger: "hover" });
            }
        } else {
            $elem.addClass("guest-mode inactive").removeClass("active");
        }


        $elem.attr("data-initialized", true);
    });
};

const initWishlist = () => {
    require("@plugin_wishlist/wishlist").initWishlist({
        onSwitcherStart() {
            $.spinner().start();
        },
        onSwitcherEnd() {
            $.spinner().stop();
        },
        onSwitcherSuccess(_, event) {
            const pid = event.pid.toString();
            
            if (event.to) {
                window.wishlistProductIds = [...new Set([...window.wishlistProductIds || [], pid])];
            } else {
                const index = (window.wishlistProductIds || []).findIndex(x => x == pid);

                if (index > -1) {
                    window.wishlistProductIds.splice(index, 1);
                }
            }
        }
    });

    $document.ready(() => {
        var $wishlistGrid = $(".ct-wishlist-product-grid");
    
        if ($wishlistGrid.length > 0) {
            $wishlistGrid[0].onload = UpdateGrid();
        }
    
        initTogglers();
    
        $document.on("initWishlistTogglers", initTogglers);
        $(".js-lazyload-template").on("lazyLoadTemplate:loaded", initTogglers);
    });
};

const UpdateGrid = () => {
    var $gridSpan = $(".section-update-url");
    var dataUrl = $gridSpan.attr("data-url");
    var dataStartIndex = parseInt($gridSpan.attr("data-start-index"), 10);
    var dataWishlistLength = parseInt($gridSpan.attr("data-wishlist-length"), 10);
    var $spinner = $(".my-product-list-load-more-products-animation");

    if (dataStartIndex >= dataWishlistLength) {
        $spinner.remove();
        return;
    }

    $spinner.removeClass("d-none");

    $.ajax({
        url: dataUrl,
        method: "GET",
        success: function (response) {
            $gridSpan.replaceWith(response);
            handleTileSync();
            globalUtilInit();
            loadLazyImages(".ct-wishlist-product-grid");
            initTogglers();
            $(".ct-wishlist-product-grid")[0].onload = UpdateGrid();
        }
    });
};

const triggerInitWishlistTogglers = () => $document.trigger("initWishlistTogglers");

export { initWishlist, UpdateGrid, triggerInitWishlistTogglers };
